Object.defineProperty(exports, "__esModule", { value: true });
exports.isInstance = void 0;
const isInstance = (document) => {
    return document['@context'] && document['@context']['@vocab'];
};
exports.isInstance = isInstance;
//# sourceMappingURL=index.js.map